module.exports = __webpack_public_path__ + "img/yellow_vip.1cd75b5c.png";